const initialState = {
  visible: null,
  payload: null,
};

export default initialState;
